import { createContext, useContext, Accessor, ParentProps, createMemo } from 'solid-js';

const ctx = () => true;
const Ctx = createContext<{
  active: Accessor<boolean>;
  deffer: Accessor<boolean>;
}>({
  active: ctx,
  deffer: ctx,
});

/**
 * 表示应用当前是否在激活，可以对离屏的应用做性能优化。
 * 当设置了value就使用value的值
 * 当没有设置value就使用intersection-observer自动检测元素是否可见, 只有第一个dom生效
 * @param props
 * @returns
 */
export function ActiveProvider(
  props: ParentProps<{
    value: boolean;
  }>
) {
  const parentActive = useIsActive();
  const active = createMemo(() => parentActive() && props.value);
  const deffer = createDeferred(active);

  return <Ctx.Provider value={{ active, deffer }}>{props.children}</Ctx.Provider>;
}

// TODO: 这个需要fixed，暂时ignore

// const [list, setList] = createSignal<Accessor<boolean>[]>([]);
// // TODO: 这个需要fixed，暂时ignore
// // eslint-disable-next-line
// createRoot((dps) => {
//   createComputed(
//     mapArray(list, (it) => {
//       createComputed(() => {
//         if (it()) {
//           const list = utmap.get(it)!;
//           onCleanup(() => {
//             for (const trigger of list.values()) {
//               trigger();
//             }
//           });
//           setList((pre) => pre.filter((v) => v !== it));
//         }
//       });
//     })
//   );
// });

// const utmap = new WeakMap<Accessor<boolean>, Set<() => void>>();

// function until(active: Accessor<boolean>, trigger: () => void) {
//   let list = utmap.get(active);
//   if (!list) {
//     list = new Set();
//     utmap.set(active, list);
//   }
//   if (list.size === 0) {
//     setList((pre) => [...pre, active]);
//   }
//   list.add(trigger);
//   onCleanup(() => list.delete(trigger));
// }

// enableExternalSource((track, trigger) => {
//   const isActive = useContext(Ctx).deffer;
//   const active = () => untrack(isActive);
//   return {
//     track: isActive !== ctx ? (v) => {
//       if (active()) {
//         return track(v);
//       } else {
//         until(isActive, trigger);
//         return v;
//       }
//     } : track,
//     dispose: () => {}
//   };
// });

/** 检查当前组件是否可用 */
export function useIsActive() {
  return useContext(Ctx).active;
}

/** 由于处理非active上下文的内容将会被冻结，所以永无无法监听false状态，所以提供这个特殊effect来处理清理
 * 一般来说你应该在这个时候 订阅/取消订阅 外部数据
 * 除此之外不需要关心应用更新数据流，整个应用状态会从源头被冻结
 */
// export function createActiveEffect (fn: () => (() => void) | void) {
//   const active = useIsActive();
//   createEffect(() => {
//     if (active()) {
//       const res = fn();
//       if (typeof res === 'function') {
//         onCleanup(res);
//       }
//     }
//   });
// }

/** 只在当前UI可用时进行更新，否则不进行更新，实现在后台挂起的时候暂停应用运行 */
// export function useActiveMemo<T>(value: Accessor<T>): Accessor<T> {
//   const active = useIsActive();
//   let cache: T | undefined;
//   return () => {
//     if (!cache || active()) {
//       cache = value();
//     }
//     return cache;
//   };
// }
